module.exports = {
      id: "fb-blue-usage",
      viewBox: "0 0 28 27.83",
      url: "/" + "sprite-94c0c4e617ccd395a266f9fdfc4a2687.svg#fb-blue",
      toString: function () {
        return this.url;
      }
    }